import { AUGoogleDistanceResult } from '@app/orders/models/map-lookup-result.model';
import { ICheckboxMultiSelectOption } from '@app/ui/checkbox-multi-select/checkbox-multi-select.component';
import { ISettingOption } from '@app/reports/report-settings/setting.model';

export class PartialPlant implements ICheckboxMultiSelectOption, ISettingOption {
  address1: string;
  address3: string;
  address5: string;
  address7: string;
  colorId: number;
  color: string;
  divisionId: number;
  id: number;
  inactiveFlag: boolean;
  latitude: string;
  longitude: string;
  name: string;
  printTicketMethod: number;
  systemType: number;
  useBatchPanelFlag: boolean;
  // for settings
  selected?: boolean;
  visible?: boolean;
  divisionAbbreviation?: string;
  /**
   * A secondary option for tracking 'selected' state on this plant model.
   * Currently only used in truck demand. For example usage: The user selects
   * a plant in the truck demand settings dialog. Those selected plants are available
   * in the mult-select available on the truck demand widget. When a user selects
   * a plant there this field will be used.
   **/
  selectionConfirmed?: boolean;

  distanceInfo?: AUGoogleDistanceResult;

  get msoKey(): number {
    return this.id;
  }

  get msoDescriptor(): string {
    return this.name;
  }

  get msoIsVisible(): boolean {
    return true;
  }

  // todo2126 could move to another object and inherit?
  get latLng(): string {
    if (this.latLngValid) {
      return `${this.latitude},${this.longitude}`;
    }

    return '';
  }

  get latLngValid(): boolean {
    return (
      this.longitude.trim() && this.latitude.trim() && this.longitude != '0' && this.latitude != '0'
    );
  }

  get addressString(): string {
    return (
      `${this.address1 || ''}${this.address1 && this.address3 ? ',' : ''} ` +
      `${this.address3 || ''} ${this.address5 || ''} ${this.address7 || ''}`
    ).trim();
  }
}
